import Vue from "vue"
import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import {
  faBars,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faCheck,
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
  faUser,
  faSpinner,
  faShoppingBasket,
  faSearch,
  faTags,
  faClockRotateLeft,
  faCopyright,
  faLocationArrow,
  faPhone,
  faEnvelope,
  faMapMarker,
  faClock,
  faCalendar,
  faLink,
  faExclamationTriangle,
  faExclamationCircle,
  faExclamation,
  faMapPin,
  faCalendarDays,
  faReceipt,
  faTruck,
  faCircleCheck,
  faMagnifyingGlass,
  faSliders,
  faHatChef,
  faCirclePlus,
  faCircleMinus,
  faInfoCircle,
  faRotateLeft,
  faLock,
  faTrash,
  faGift,
  faEye,
  faDownload,
  faPrint,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faSealQuestion,
  faPencil,
  faArrowLeft,
} from "@fortawesome/pro-light-svg-icons"

import { faRotateRight } from "@fortawesome/pro-regular-svg-icons"

import {
  faXmark,
  faStar,
  faShoppingCart,
  faFaceSmile,
  faFaceFrown,
} from "@fortawesome/pro-solid-svg-icons"

import {
  faFacebook,
  faTwitter,
  faXTwitter,
  faInstagram,
  faLinkedin,
  faGoogle,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons"

library.add(
  faBars,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faCheck,
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
  faUser,
  faSpinner,
  faShoppingBasket,
  faSearch,
  faTags,
  faClockRotateLeft,
  faCopyright,
  faLocationArrow,
  faPhone,
  faEnvelope,
  faMapMarker,
  faClock,
  faCalendar,
  faLink,
  faExclamationTriangle,
  faExclamationCircle,
  faExclamation,
  faMapPin,
  faCalendarDays,
  faReceipt,
  faTruck,
  faCircleCheck,
  faMagnifyingGlass,
  faSliders,
  faHatChef,
  faCirclePlus,
  faCircleMinus,
  faInfoCircle,
  faRotateLeft,
  faLock,
  faTrash,
  faGift,
  faEye,
  faDownload,
  faPrint,
  faArrowRight,
  faArrowLeft,
  faArrowUp,
  faArrowDown,
  faSealQuestion,
  faRotateRight,
  faXmark,
  faPencil,
  faStar,
  faShoppingCart,
  faFaceSmile,
  faFaceFrown,
  faFacebook,
  faXTwitter,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGoogle,
  faWhatsapp
)

config.autoAddCss = true

Vue.component("fa", FontAwesomeIcon)
